module.exports = __webpack_public_path__ + "static/media/sitter.aeaaa08b.png";